import { Box, Icon } from '@fullstory/components';
import { useHover } from '@fullstory/react-hooks';
import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import css from './PlayOverlay.module.scss';

interface PlayOverlayProps {
  /** URL to navigate to when play button is clicked */
  to: React.ComponentProps<typeof Link>['to'];
  /** Optional callback when play button is clicked */
  onClick?: () => void;
  /** Optional flag to open in new tab */
  newTab?: boolean;
  /** Content to display under the overlay */
  children: ReactNode;
}

export const PlayOverlay: React.FC<PlayOverlayProps> = ({ to, onClick, newTab, children }) => {
  const { hovered, hoverProps } = useHover();
  return (
    <div data-testid="PlayOverlay" className={css.container} {...hoverProps}>
      {children}
      {hovered && (
        <Link
          to={to}
          target={newTab ? '_blank' : '_self'}
          onClick={onClick}
          className={css.overlay}
        >
          <Box className={css.playButtonContainer}>
            <Icon name="play" size={20} color="default-inverse" />
          </Box>
        </Link>
      )}
    </div>
  );
};
